import React, { useEffect, useState } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { closeButtonStyle, Saveandadduser } from "../components/Propertyfile";
import { List_Checker, RoleandMapping, createTextFileApi, shariahconfig, mappingdata, OwnershipApi, userinfo, ListAllusers, residualSaveApi, residualListApi } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { Modal, Button } from 'react-bootstrap';

const GapsyResidualConfig = () => {
    const [filteredUsers, setFilteredUsers] = useState([]);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry
    const [modalMessage3, setModalMessage3] = useState('');
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        searchUserId: "",
        userFirstName: ""
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedChecker, setSelectedChecker] = useState('');
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    // const [permissions, setPermissions] = useState({
    //     viewMaker: false,
    //     viewChecker: false,
    //     viewRiskOfficer: false,
    //     downloadMaker: false,
    //     downloadChecker: false,
    //     downloadRiskOfficer: false,
    // });
    const initialPermissions = {
        // viewMaker: false,
        downloadMaker: false,
        // viewChecker: false,
        downloadChecker: false,
        // viewRiskOfficer: false,
        downloadRiskOfficer: false,
    };

    const [permissions, setPermissions] = useState(initialPermissions);


    const [selectedTemplate, setSelectedTemplate] = useState("");

    const [templateSearch, setTemplateSearch] = useState("");

    const [showTemplateDropdown, setShowTemplateDropdown] = useState(false);

    const [templateWorkflows, setTemplateWorkflows] = useState({});

    const [selectedWorkflow, setSelectedWorkflow] = useState("");

    const [existingTemplates, setExistingTemplates] = useState([]);

    const workflowOptions = [
        {
            id: "workflow-1",
            label: "Maker → Checker → Risk Officer → Risk User",
            roles: [
                "Maker",
                "Checker",
                "Risk User",
                "Risk Officer"
            ]
        },
        {
            id: "workflow-2",
            label: "Maker → Checker → Risk Officer",
            roles: [
                "Maker",
                "Checker",
                "Risk Officer"
            ]
        }
    ];

    const riskTemplates = [
        "Shariah",
        "Residual Operational Risk"
    ];

    const availableRoles = [
        "Maker",
        "Checker",
        "Risk Officer",
        "Risk User"       
    ];


    const handleTemplateCheckboxChange = (template) => {

        setSelectedTemplate((previousTemplates) => {

            if (previousTemplates.includes(template)) {

                return previousTemplates.filter(
                    (item) => item !== template
                );

            }

            return [
                ...previousTemplates,
                template
            ];

        });

    };

    const filteredRiskTemplates = riskTemplates.filter(
        (template) =>
            template
                .toLowerCase()
                .includes(
                    templateSearch.toLowerCase()
                )
    );

    const handleSave = async (e, allowUpdate = "") => {
        e.preventDefault();

        const adminId = localStorage.getItem("userid") || "";
        const dept = sessionStorage.getItem("dept") || "";

        // --------------------------------------------------
        // Validation
        // --------------------------------------------------

        if (selectedTemplate.length === 0) {
            setMessageType("error");
            setModalMessage("Please select at least one Risk Template.");
            setShowModal(true);
            return;
        }

        if (!selectedWorkflow) {
            setMessageType("error");
            setModalMessage("Please select a Workflow Approval Role.");
            setShowModal(true);
            return;
        }

        if (!adminId) {
            setMessageType("error");
            setModalMessage("Admin ID is not available.");
            setShowModal(true);
            return;
        }

        // --------------------------------------------------
        // Get selected workflow
        // --------------------------------------------------

        const selectedWorkflowData = workflowOptions.find(
            (workflow) => workflow.id === selectedWorkflow
        );

        if (!selectedWorkflowData) {
            setMessageType("error");
            setModalMessage("Invalid workflow selected.");
            setShowModal(true);
            return;
        }

        // --------------------------------------------------
        // Convert roles
        // Maker → Checker → Risk User → Risk Officer
        // becomes
        // Maker,Checker,Risk User,Risk Officer
        // --------------------------------------------------

        const workflowRoles = selectedWorkflowData.roles.join(",");

        // --------------------------------------------------
        // Build permissions
        // --------------------------------------------------

        const permissions = [
            {
                template: selectedTemplate,
                [selectedWorkflow]: workflowRoles,
                Active: "Y",
            }
        ];

        // --------------------------------------------------
        // Build final JSON
        // --------------------------------------------------

        const jsonData = {
            template: "Residual Risk",
            adminId: adminId,
            permissions: permissions,
        };

        /*
         * IMPORTANT:
         *
         * JSON.stringify(..., null, 2) creates formatted JSON.
         * If createTextFileApi expects "content" as a string,
         * this is correct.
         */
        const content = JSON.stringify(jsonData, null, 2);

        const filename = `${adminId}_workflow.json`;

        try {
            // --------------------------------------------------
            // Start Loader
            // --------------------------------------------------

            setIsLoading(true);

            // --------------------------------------------------
            // Step 1: Create JSON File
            // --------------------------------------------------

            await axios.post(
                createTextFileApi,
                {
                    filename: filename,
                    content: content,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        userId: adminId,
                        "x-csrf-token": csrfToken,
                    },
                    withCredentials: true,
                }
            );

            // --------------------------------------------------
            // Step 2: Mapping / Save API
            // --------------------------------------------------

            const config = {
                headers: {
                    adminId: adminId,
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    filePath: `/ saswork / nas / ${filename} `,
                    Notifications: "IN",
                    templateName: "Risk_shariah_pillar1",
                    dept: dept,
                    allowUpdate: allowUpdate,
                },
            };

            const configResponse = await axios.post(
                residualSaveApi,
                {},
                config
            );

            // --------------------------------------------------
            // Get API Response
            // --------------------------------------------------

            const responseData = configResponse?.data || {};

            const status = String(
                responseData?.status || ""
            ).toLowerCase();

            const message =
                responseData?.message ||
                responseData?.msg ||
                responseData?.error ||
                "";

            // --------------------------------------------------
            // Existing Configuration
            // --------------------------------------------------

            if (status === "update") {
                setPendingPayload(true);

                setModalMessage3(
                    "Configuration already exists.<br/>Do you want to update?"
                );

                setShowAllowUploadPopup(true);

                return;
            }

            // --------------------------------------------------
            // SUCCESS
            // --------------------------------------------------

            if (status === "success") {
                setMessageType("success");

                setModalMessage(
                    message ||
                    "Workflow configuration saved successfully."
                );

                setShowModal(true);

                return;
            }

            // --------------------------------------------------
            // FAILURE RESPONSE FROM API
            // --------------------------------------------------

            setMessageType("error");

            setModalMessage(
                message ||
                "Failed to save workflow configuration."
            );

            setShowModal(true);

        } catch (error) {

            // --------------------------------------------------
            // API / Network Error
            // --------------------------------------------------

            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to save workflow configuration.";

            setMessageType("error");
            setModalMessage(errorMessage);
            setShowModal(true);

        } finally {

            // --------------------------------------------------
            // Stop Loader
            // --------------------------------------------------

            setIsLoading(false);
        }
    };


    const handleReset = () => {
        setSelectedTemplate([]);
        setSelectedWorkflow("");
        setTemplateSearch("");
        setShowTemplateDropdown(false);
    };

    const fetchDepartments = async () => {
        try {
            setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchDepartments();
    }, []);

    useEffect(() => {
        const fetchUsersData = async () => {
            try {
                setIsLoading(true);

                const config = {
                    params: { adminId: localStorage.getItem('userid') },
                    headers: { 'x-csrf-token': csrfToken },
                    withCredentials: true
                };

                // Parallel API calls
                const [allUsersRes, mappedUsersRes] = await Promise.all([
                    axios.post(ListAllusers, {}, config),
                    axios.post(RoleandMapping, {}, {
                        ...config,
                        params: {
                            ...config.params,
                            tableName: "user_role_mapping"
                        }
                    })
                ]);

                const allUsers = allUsersRes.data.users || [];

                const mappedUserIds = new Set(
                    (mappedUsersRes.data.data || []).map(item => String(item.USERID))
                );

                // FILTER: remove mapped users
                const filtered = allUsers.filter(
                    user => !mappedUserIds.has(String(user.userId))
                );

                setUsers(filtered);
                setFilteredUsers(filtered);

            } catch (error) {
                console.error("Error fetching users!", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsersData();
    }, []);

    const handleUserSelect = (e) => {
        const selectedId = e.target.value;

        const selectedUser = users.find(
            (user) => user.userId === selectedId
        );

        setFormData((prev) => ({
            ...prev,
            searchUserId: selectedId,
            userFirstName: selectedUser?.userFirstName || ""
        }));
    };





    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleRaf = (e) => {
        e.preventDefault();
        navigate('/GapsyResidualListConfig');
        // Additional logic if needed
    };

    const handleCloseModal = () => {
        setModalMessage('');
    };

    const handleCloseLdap = () => {
        const wasSuccess = messageType === "success";

        setShowModal(false);
        setModalMessage("");
        setMessageType("");

        if (wasSuccess) {
            handleReset();
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            setIsLoading(true);

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    templateName: "All",
                },
            };

            const response = await axios.post(
                residualListApi,
                {},
                config
            );

            console.log("API Response:", response.data);

            const permissions = response.data?.permissions || [];

            // Convert API response into table data
            const apiData = permissions.map((item) => ({
                template: item.template,
                workflow: item.workflow,
                active: item.Active,

                roles: item.workflow_action
                    ? item.workflow_action
                        .split(",")
                        .map((role) => role.trim())
                    : [],
            }));

            console.log("Formatted Table Data:", apiData);

            setUsers(apiData);
            setFilteredUsers(apiData);

            // Get templates which already exist in DB
            const existingTemplates = permissions
                .map((item) => item.template?.trim().toLowerCase())
                .filter(Boolean);

            console.log("Existing Templates:", existingTemplates);

            setExistingTemplates(existingTemplates);

        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`} style={{ cursor: "pointer" }} aria-current="page">
                                    <a onClick={handleRaf} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-diagram-3 me-2" ></i>Workflow Configuration
                                    </a>
                                </li>
                                {/* <li className={`breadcrumb-item ${styles.breadcrumbItem}`} aria-current="page">
                                    <i onClick={handleRaf} className="bi bi-person-plus me-2"></i>RAF - User - Role Mapping
                                </li> */}
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>Add New Workflow
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className='row'>
                                    <div className="col justify-content-center">
                                        <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                            <div className="card-body">
                                                <div className="mb-0">
                                                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Add New Workflow</h6>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="w-100" style={{ maxWidth: '700px' }}>
                                                            <div className={`mx-auto ${formStyles.formWrapper}`}>
                                                                <form className="form px-5" onSubmit={handleSave}>
                                                                    {/* Risk Template Selection */}

                                                                    <div className="form-group row mb-3">

                                                                        <label className="col-sm-4 col-form-label label-black">
                                                                            Risk Template Name
                                                                            <span className="text-danger ms-1">*</span>
                                                                        </label>

                                                                        <div className="col-sm-7">

                                                                            <select
                                                                                className="form-select"
                                                                                value={selectedTemplate}
                                                                                onChange={(e) => {
                                                                                    setSelectedTemplate(e.target.value);
                                                                                }}
                                                                            >
                                                                                <option value="">
                                                                                    Select Risk Template
                                                                                </option>

                                                                                {filteredRiskTemplates.map((template) => {

                                                                                    const isAlreadyExists = existingTemplates.includes(
                                                                                        template.trim().toLowerCase()
                                                                                    );

                                                                                    return (
                                                                                        <option
                                                                                            key={template}
                                                                                            value={template}
                                                                                            disabled={isAlreadyExists}
                                                                                        >
                                                                                            {template}
                                                                                            {isAlreadyExists ? " (Already Configured)" : ""}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>

                                                                        </div>

                                                                    </div>
                                                                    {/* Workflow Configuration Header */}

                                                                    {selectedTemplate.length > 0 && (

                                                                        <div className="form-group row mb-4">

                                                                            <label className="col-sm-4 col-form-label label-black">

                                                                                Workflow Approval Roles
                                                                                <span className="text-danger ms-1">*</span>

                                                                            </label>


                                                                            <div className="col-sm-7">

                                                                                <div className="border rounded p-3">

                                                                                    <div className="mb-3">

                                                                                        <small className="text-muted">
                                                                                            Select one approval workflow for the selected templates.
                                                                                        </small>

                                                                                    </div>


                                                                                    {workflowOptions.map((workflow) => (

                                                                                        <div
                                                                                            className="form-check mb-3"
                                                                                            key={workflow.id}
                                                                                        >

                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name="workflowApproval"
                                                                                                id={workflow.id}
                                                                                                value={workflow.id}
                                                                                                checked={
                                                                                                    selectedWorkflow === workflow.id
                                                                                                }
                                                                                                onChange={(e) =>
                                                                                                    setSelectedWorkflow(
                                                                                                        e.target.value
                                                                                                    )
                                                                                                }
                                                                                            />


                                                                                            <label
                                                                                                className="form-check-label"
                                                                                                htmlFor={workflow.id}
                                                                                            >

                                                                                                {workflow.label}

                                                                                            </label>

                                                                                        </div>

                                                                                    ))}


                                                                                    {/* Selected Workflow */}

                                                                                    {selectedWorkflow && (

                                                                                        <div className="mt-3 pt-3 border-top">

                                                                                            <small className="text-muted">
                                                                                                Selected Workflow:
                                                                                            </small>

                                                                                            <div className="mt-2">

                                                                                                <span className="badge bg-primary p-2">

                                                                                                    {
                                                                                                        workflowOptions.find(
                                                                                                            workflow =>
                                                                                                                workflow.id ===
                                                                                                                selectedWorkflow
                                                                                                        )?.label
                                                                                                    }

                                                                                                </span>

                                                                                            </div>

                                                                                        </div>

                                                                                    )}

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    )}
                                                                    <div className="row mt-4 mx-4 mb-4">

                                                                        <div className="col-sm-4"></div>

                                                                        <div className="col-sm-7 d-flex">

                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-sm btn-primary me-2"
                                                                            >
                                                                                <i className="bi bi-save me-1"></i>
                                                                                Save
                                                                            </button>

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-secondary"
                                                                                onClick={handleReset}
                                                                            >
                                                                                <i className="bi bi-arrow-counterclockwise me-1"></i>
                                                                                Reset
                                                                            </button>

                                                                        </div>

                                                                    </div>
                                                                </form>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Modal
                                            show={showModal}
                                            onHide={handleCloseLdap}
                                            backdrop="static"
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            color: messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? '#ffc107'
                                                                    : 'red'
                                                        }}
                                                    >
                                                        {modalMessage}
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleCloseLdap}
                                                    style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                                />
                                            </div>
                                        </Modal>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyResidualConfig;
